import { ParsedUrlQuery } from 'querystring';
import { routes } from '~/core/router';
import { LocalStorageService } from '~/core/utils/storage';
import {
  CONTENT_SEARCH_ROSTER,
  IContentSearchQuery,
} from '~/hooks/useContentSearch';

import {
  FILTER_DEFAULTS,
  GLOBAL_FILTER_DEFAULTS,
  SEARCH_PROP,
} from './SearchContent.constants';
import { ISearchContentQuery } from './SearchContent.types';

export const getQueryParams = (
  query: ParsedUrlQuery,
  pathname?: string,
): Partial<ISearchContentQuery> & typeof FILTER_DEFAULTS => {
  const selectedRoster =
    LocalStorageService.getItem<CONTENT_SEARCH_ROSTER>('talentOption') ??
    CONTENT_SEARCH_ROSTER.myTalent;

  const FILTERS =
    pathname !== routes.globalSearch ? FILTER_DEFAULTS : GLOBAL_FILTER_DEFAULTS;

  return {
    ...FILTERS,
    ...query,
    roster: selectedRoster,
  };
};

export const removeEmptyUrlParams = (
  searchProps: IContentSearchQuery,
): ISearchContentQuery => {
  const cleanedParams: ISearchContentQuery = {};

  Object.entries(searchProps).forEach(
    ([key, value]: [SEARCH_PROP, string | undefined]) => {
      if (value) {
        Object.assign(cleanedParams, { [key]: value });
      }
    },
  );

  return cleanedParams;
};
